import React, { Component } from "react";
import { stock } from "../../api";

class StockTicker extends Component {
  state = {
    data: null,
    loading: true,
    error: null,
  };

  async componentDidMount() {
    try {
      const result = await stock.stockRepo.getSafkar();
      this.setState({ data: result, loading: false });
    } catch (err) {
      console.error("StockTicker Error:", err);
      this.setState({ error: err, loading: false });
    }
  }

  render() {
    const { data, loading, error } = this.state;

    if (loading) {
      return (
        <div className="gemini-ticker-card loading">
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <style>{`
            .gemini-ticker-card.loading {
              display: flex;
              justify-content: center;
              align-items: center;
              min-height: 200px;
              background: linear-gradient(135deg, #0055a5 0%, #003366 100%);
              border-radius: 24px;
            }
          `}</style>
        </div>
      );
    }

    if (error || !data || !data.meta) return null;

    const meta = data.meta;
    const price = meta.regularMarketPrice;
    const previousClose = meta.chartPreviousClose;
    const change = price - previousClose;
    const changePercent = (change / previousClose) * 100;
    const isPositive = change >= 0;
    const currency = meta.currency;

    const { lang } = this.props;
    const locale = lang === "en" ? "en-US" : "tr-TR";
    const lastUpdateLabel = lang === "en" ? "Last Updated" : "Son Güncelleme";

    const lastUpdate = new Date(
      meta.regularMarketTime * 1000
    ).toLocaleDateString(locale, {
      hour: "2-digit",
      minute: "2-digit",
    });

    return (
      <>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;600;700&display=swap');

          .gemini-ticker-card {
            font-family: 'Outfit', sans-serif;
            background: linear-gradient(145deg, #0055a5 0%, #002a52 100%);
            border-radius: 24px;
            padding: 18px;
            position: relative;
            overflow: hidden;
            box-shadow: 0 10px 30px -10px rgba(0, 85, 165, 0.5);
            border: 1px solid rgba(255, 255, 255, 0.15);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
            color: #ffffff;
          }

          .gemini-ticker-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.6);
            border-color: rgba(255, 255, 255, 0.15);
          }

          /* Decorative Glow */
          .gemini-glow {
            position: absolute;
            top: -50px;
            right: -50px;
            width: 150px;
            height: 150px;
            background: radial-gradient(circle, rgba(66, 133, 244, 0.4) 0%, rgba(0, 0, 0, 0) 70%);
            filter: blur(40px);
            z-index: 0;
            pointer-events: none;
          }

          .gemini-glow-2 {
            position: absolute;
            bottom: -30px;
            left: -30px;
            width: 120px;
            height: 120px;
            background: radial-gradient(circle, rgba(219, 68, 55, 0.2) 0%, rgba(0, 0, 0, 0) 70%);
            filter: blur(30px);
            z-index: 0;
            pointer-events: none;
          }

          .gemini-content {
            position: relative;
            z-index: 1;
          }

          .gemini-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 5px;
          }

          .gemini-symbol {
            font-size: 1rem;
            font-weight: 700;
            letter-spacing: 1px;
            color: rgba(255, 255, 255, 0.9);
            display: flex;
            align-items: center;
            gap: 8px;
          }

          .gemini-symbol i {
            font-size: 0.9rem;
            color: #4285f4; /* Google Blue */
          }

          .gemini-badge {
            font-size: 0.75rem;
            padding: 2px 5px;
            border-radius: 20px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .gemini-badge.positive {
            background: rgba(52, 168, 83, 0.15);
            color: #81c995;
            border: 1px solid rgba(52, 168, 83, 0.2);
          }

          .gemini-badge.negative {
            background: rgba(234, 67, 53, 0.15);
            color: #f28b82;
            border: 1px solid rgba(234, 67, 53, 0.2);
          }

          .gemini-price-section {
            display: flex;
            flex-direction: column;
            gap: 4px;
          }

          .gemini-price {
            font-size: 1.5rem;
            font-weight: 700;
            line-height: 1;
            background: linear-gradient(180deg, #ffffff 0%, #e0e0e0 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          .gemini-currency {
            font-size: 1.2rem;
            color: rgba(255, 255, 255, 0.6);
            font-weight: 400;
            margin-left: 8px;
            vertical-align: super;
          }

          .gemini-change-row {
            display: flex;
            align-items: center;
            gap: 12px;
          }

          .gemini-change-val {
            font-size: 0.8rem;
            font-weight: 500;
          }

          .gemini-change-val.positive { color: #81c995; }
          .gemini-change-val.negative { color: #f28b82; }

          .gemini-footer {
            margin-top: 10px;
            padding-top: 5px;
            border-top: 1px solid rgba(255, 255, 255, 0.08);
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 0.8rem;
            color: rgba(255, 255, 255, 0.4);
          }

          .gemini-sparkle-icon {
            color: #fbbc04; /* Google Yellow */
            animation: spin-pulse 3s infinite ease-in-out;
          }

          @keyframes spin-pulse {
            0% { transform: scale(1) rotate(0deg); opacity: 0.8; }
            50% { transform: scale(1.2) rotate(180deg); opacity: 1; }
            100% { transform: scale(1) rotate(360deg); opacity: 0.8; }
          }
        `}</style>

        <div className="gemini-ticker-card">
          <div className="gemini-glow"></div>
          <div className="gemini-glow-2"></div>

          <div className="gemini-content">
            <div className="gemini-header">
              <div className="gemini-symbol">
                <i className="fas fa-chart-line"></i>
                {meta.symbol}
              </div>
              <div className="gemini-badge positive">
                <div className="gemini-change-row">
                  <span
                    className={`gemini-change-val ${
                      isPositive ? "positive" : "negative"
                    }`}
                  >
                    <i
                      className={`fas fa-arrow-${
                        isPositive ? "up" : "down"
                      } me-1`}
                    ></i>
                    {Math.abs(change).toFixed(2)} (
                    {Math.abs(changePercent).toFixed(2)}%)
                  </span>
                </div>
              </div>
            </div>

            <div className="gemini-price-section">
              <div className="gemini-price">
                {price.toFixed(2)}
                <span className="gemini-currency">{currency}</span>
              </div>
            </div>

            <div className="gemini-footer">
              <span>
                {lastUpdateLabel}: {lastUpdate}
              </span>
              <i className="fas fa-star gemini-sparkle-icon"></i>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default StockTicker;
